(function () {

  function sydneyTodayISO() {
    return new Intl.DateTimeFormat('en-CA', {
      timeZone: 'Australia/Sydney',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit'
    }).format(new Date());
  }

  function enforceMin(input) {
    var min = sydneyTodayISO();

    if (input.getAttribute('min') !== min) {
      input.setAttribute('min', min);
    }


    if (input.value && input.value < min) {
      input.value = min;
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  function fixDateInput(input) {
    if (!input || input.dataset.quotifyDateFixed) {
   
      if (input) enforceMin(input);
      return;
    }
    input.dataset.quotifyDateFixed = 'true';

    enforceMin(input);

   
    input.addEventListener('input', function () {
      var min = sydneyTodayISO();
      if (input.value && input.value < min) {
        input.value = min;
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });

    input.addEventListener('change', function () {
      enforceMin(input);
    });

  
    input.addEventListener('blur', function () {
      enforceMin(input);
    });
  }

  function scanForQuotifyDateFields(root) {
    root.querySelectorAll('[data-quotify-field-type="date"] input[type="date"]').forEach(fixDateInput);
  }

 
  scanForQuotifyDateFields(document);

 
  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.type === 'childList') {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.matches && node.matches('[data-quotify-field-type="date"] input[type="date"]')) {
            fixDateInput(node);
          }
          if (node.querySelectorAll) {
            scanForQuotifyDateFields(node);
          }
        });
      }
      if (mutation.type === 'attributes' && mutation.target.matches('input[type="date"]')) {
        var el = mutation.target;
        if (el.closest('[data-quotify-field-type="date"]')) {
          enforceMin(el);
        }
      }
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['min', 'value']
  });

  setInterval(function () {
    scanForQuotifyDateFields(document);
  }, 1000);
})();
